import {
  LIST_ADMIN,
  LIST_ORGANIZER,
  CREATE_ADMIN,
  UPDATE_ADMIN,
  DELETE_ADMIN,
  CREATE_ORGANIZER,
  UPDATE_ORGANIZER,
  UPDATE_ORGANIZER_AS_ADMIN,
  INACTIVATE_ORGANIZER,
  ACTIVATE_ORGANIZER,
} from './config';

export async function getAdmins() {
  const url = LIST_ADMIN;
  const token = localStorage.getItem('token');

  const users = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta användare');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return users;
}

export async function getOrganizers() {
  const url = LIST_ORGANIZER;
  const token = localStorage.getItem('token');

  const users = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error('Kunde inte hämta användare');
      }
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return users;
}

export async function createAdministrator(data) {
  const url = CREATE_ADMIN;
  const token = localStorage.getItem('token');

  let status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return status;
}

export async function updateAdministrator(data) {
  const url = UPDATE_ADMIN;
  const token = localStorage.getItem('token');

  let status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return status;
}

export async function deleteAdministrator(adminId) {
  const url = DELETE_ADMIN.replace('{adminId}', adminId);
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'DELETE',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function createOrganizer(data) {
  const url = CREATE_ORGANIZER;
  const token = localStorage.getItem('token');

  let status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return status;
}

export async function updateOrganizer(data) {
  const url = UPDATE_ORGANIZER;
  const token = localStorage.getItem('token');

  let status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.error(err);
    });

  return status;
}

export async function updateOrganizerAsAdmin(id, data) {
  const url = UPDATE_ORGANIZER_AS_ADMIN.replace('{organizerId}', id);
  const token = localStorage.getItem('token');

  let status = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return status;
}

export async function inactivateOrganizer(organizerId) {
  const url = INACTIVATE_ORGANIZER.replace('{organizerId}', organizerId);
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}

export async function activateOrganizer(organizerId) {
  const url = ACTIVATE_ORGANIZER.replace('{organizerId}', organizerId);
  const token = localStorage.getItem('token');

  const result = await fetch(url, {
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      return data;
    })
    .catch((err) => {
      //console.error(err);
    });

  return result;
}
